export default {"surface":"iRCJpG_surface","menu":"iRCJpG_menu","sm":"iRCJpG_sm","sheet":"iRCJpG_sheet","inline":"iRCJpG_inline",}